import baseUrl from '@/utils/api';
import noCover from '@/assets/images/no-cover.png';
import merge from 'webpack-merge';
import { token } from '@/utils';
import { setFee } from '@/api/courseOn';
import VueCookie from 'vue-cookie';

let hartTime = null;
export default {
  name: 'myRecord',
  inject: ['reload'],
  data() {
    return {
      loading: false,
      noCover,
      list: {},
      api: '',

      status: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '上课中',
          value: 2,
        },
        {
          label: '未开始',
          value: 1,
        },
        {
          label: '已结束',
          value: 3,
        },
      ],
      type: [
        // {
        //   label: '全部',
        //   value: ''
        // },
        // {
        //   label: '链接直播间',
        //   value: 2
        // },
        // {
        //   label: '班级直播间',
        //   value: 1
        // },
        {
          label: '线下课',
          value: 3,
        },
      ],

      check_status: '',
      check_type: '',

      forms: {},

      tableSearch: {
        preSelect: {
          value: '',
          select: '',
          option: [
            {
              label: '课堂名称',
              value: 'name',
            },
            {
              label: '课件标题',
              value: 'course_title',
            },
          ],
        },
      },

      myScreen: {
        show: false,
        loading: false,
        roomid: this.$route.query.roomid,
        teacher_id: this.$route.query.teacher_id,

        classInfo: [], // 班级

        course: '',
        version: '',
        students: [],
      },
      myScreenDialog: {
        src: '',
        show: false,
        loading: false,
        isfull: false,
      },
      myScreenError: {
        show: false,
      },
      token: token.get(),
      rollFeeFun: null, // 轮询收费
    };
  },
  created() {
    const openScreen = localStorage.getItem('open_screen', 1);

    if (openScreen) {
      setTimeout(() => {
        localStorage.removeItem('open_screen');
      }, 500);

      if (this.myScreen.roomid) {
        this.myScreen.show = true;

        const courseInfo = JSON.parse(localStorage.getItem('my_class_data'));

        const classInfo = JSON.parse(localStorage.getItem('my_screen_formclasses'));

        setTimeout(() => {
          localStorage.removeItem('my_class_data');
          localStorage.removeItem('my_screen_formclasses');
        }, 500);

        this.myScreen.classInfo = classInfo;

        this.myScreen.course_id = courseInfo.id;
        this.myScreen.name = courseInfo.name;
        this.myScreen.title = courseInfo.title;

        this.$router.replace({
          query: merge({
            page: 1,
            per_page: 10,
          }),
        });
      }
    }

    this.api = `/api/liveroom?equal[teacher_id]=${this.$store.state.user.id}&order[is_live]=desc&order[status]=asc&order[start_time]=desc&equal[type]=3`;

    this.searchPage(this.$route.query);

    // if (this.$store.state.from === 'schoolCenter') {
    //   this.type = [
    //     {
    //       label: '全部',
    //       value: ''
    //     },
    //     {
    //       label: '互动直播课',
    //       value: 1
    //     },
    //     {
    //       label: '线下互动课',
    //       value: 3
    //     },
    //   ];
    // }
  },
  mounted() {
    this.$store.state.iframeFn = (type, data) => {
      switch (type) {
        case 'webgetCourseRoomInfo':
          const roleInfo = {
            role: 'teacher',
            uuid: this.$store.state.user.uuid,
            name: this.$store.state.user.name,
            teacherId: this.myScreen.teacher_id,
            roomId: this.myScreen.roomid,
          };

          const roomInfo = {
            app: {
              course: this.myScreen.course,
              config_version: this.myScreen.version,
            },
            roleInfo,
            students: this.myScreen.students,
          };

          myScreenIframe.contentWindow.postMessage(
            {
              index: data.index,
              type: 'cocosgetCourseRoomInfo',
              value: roomInfo,
            },
            '*',
          );

          break;

        case 'webloadCompleted':
          this.myScreenDialog.loading = false;
          break;

        case 'webbackLesson':
          this.myScreenDialog.show = false;
          break;

        case 'webfinishClass':
          this.myScreenStatus(3, () => {
            this.myScreen.show = false;
            this.myScreenDialog.show = false;
          });
          break;
        case 'webfullScreen':
          if (this.myScreenDialog.isfull) {
            this.exitScreen();
          } else {
            this.fullScreen(myScreenIframe);
          }

          this.myScreenDialog.isfull = !this.myScreenDialog.isfull;
          console.log('isFullScreen');
          break;
      }
    };
  },
  destroyed() {
    this.$store.state.iframeFn = undefined;
  },
  methods: {
    rollHeart() {
      const heartStart = VueCookie.get('heartStart');
      if (heartStart === 'end') {
        clearTimeout(this.rollFeeFun);
        this.exitScreen()
        // this.myScreenDialog.show = false;
        window.clearTimeout(hartTime);
        hartTime = null;
      }
      hartTime = window.setTimeout(() => {
        this.rollHeart();
      }, 5000);
      this.$once('hook:beforeDestroy', () => {
        window.clearTimeout(hartTime);
        hartTime = null;
      });
    },
    searchPage({
      type,
      status = 2,
      page = 1,
      per_page = 10,
    } = {}) {
      type !== undefined && (this.check_type = type);
      status !== undefined && (this.check_status = status);

      let apis = `${this.api}&page=${page}&per_page=${per_page}`;

      this.check_type && (apis += `&equal[type]=${this.check_type}`);
      this.check_status && (apis += `&equal[status]=${this.check_status}`);

      if (this.tableSearch.preSelect.select) {
        apis += `&like[${this.tableSearch.preSelect.select}]=${this.tableSearch.preSelect.value}`;
      }

      if (this.forms.created_at) {
        apis += `&between[created_at][]=${this.forms.created_at[0]}&between[created_at][]=${this.forms.created_at[1]}`;
      }

      this.api && this.$http.get(apis).then((res) => {
        this.list = res;
      });

      this.$router.replace({
        query: merge(this.$route.query, {
          page,
          per_page,
          type: this.check_type,
          status: this.check_status,
        }),
      });

      this.$forceUpdate();
    },

    // 去上课
    getMyScreen(item) {
      // if (this.$permissions('school_classes_list_edit')) {
      //   this.$message({
      //     message: '无权限上课',
      //     type: 'warning'
      //   });
      //   return;
      // }

      if (item.type === 1) {
        this.$message({
          message: '暂不支持互动直播课',
          type: 'warning',
        });
      } else {
        this.myScreen.show = true;

        this.myScreen.roomid = item.id;
        this.myScreen.course_id = item.course_id;
        this.myScreen.teacher_id = item.teacher_id;
        this.myScreen.name = item.name;
        this.myScreen.title = item.title;

        this.myScreenStart(item.status);
      }
    },

    transfer({ page = 1, per_page = 10 } = {}) {
      this.searchPage({
        page,
        per_page,
      });
    },

    // 全屏
    fullScreen(e) {
      console.log('全屏中');
      this.rollHeart();
      if (e.requestFullscreen) {
        e.requestFullscreen().catch(this.disFullScreen);
      } else if (e.msRequestFullscreen) {
        e.msRequestFullscreen().catch(this.disFullScreen);
      } else if (e.mozRequestFullScreen) {
        e.mozRequestFullScreen().catch(this.disFullScreen);
      } else if (e.webkitRequestFullScreen) {
        e.webkitRequestFullScreen().catch(this.disFullScreen);
      }
    },

    // 全屏 - 退出
    exitScreen() {
      const e = document;
      if (e.exitFullscreen) {
        e.exitFullscreen().catch(this.disFullScreen);
      } else if (e.msExitFullscreen) {
        e.msExitFullscreen().catch(this.disFullScreen);
      } else if (e.mozCancelFullScreen) {
        e.mozCancelFullScreen().catch(this.disFullScreen);
      } else if (e.webkitCancelFullScreen) {
        e.webkitCancelFullScreen().catch(this.disFullScreen);
      }
    },

    // 无法全屏
    disFullScreen() {
      // .
    },

    // 上课 - 更新状态
    myScreenStatus(status = 2, callback = Function) {
      this.$http.patch(`/api/liveroom/${this.myScreen.roomid}/status`, {
        status,
      }).then(() => {
        callback();
      });
    },

    emptyCourse() {
      this.myScreen.loading = false;
      this.myScreenError.show = true;
    },

    classBack() {
      this.myScreenError.show = false;
      this.myScreen.show = false;
    },

    // 上课 - 开始
    myScreenStart(status) {
      this.myScreen.loading = true;

      this.$http.get(`${baseUrl}/api/courseware/result/${this.myScreen.course_id}?clients_id=${this.$store.state.appId}&config_type=web_url`).then((res) => {
        this.myScreen.course = res.data.attr_used ? res.data.attr_used.cocos_remote : '';
        this.myScreen.version = res.data.config_version;

        if (!this.myScreen.course) {
          this.emptyCourse();
          return;
        }

        this.$http.get(`/api/liveroom/${this.myScreen.roomid}/student`).then((res1) => {
          const data = res1.items;
          const arr = [];

          data.forEach((item) => {
            arr.push({
              uuid: item.student.id,
              name: item.student.name,
              avatar: item.student.headimgurl,
            });
          });

          this.myScreen.students = arr;

          this.$http.get(`${baseUrl}/api/app-packet/cocos/last`).then((res2) => {
            const _o = {
              url: res2.data.attach.unpack_url,
              roomid: this.myScreen.roomid,
              teacher_id: this.myScreen.teacher_id,
              uuid: this.$store.state.uuid,
              clientid: this.$store.state.appId,
              token: this.token,
            };

            if (status === 2) {
              this.startFn(_o);
            } else {
              this.myScreenStatus(2, () => {
                this.startFn(_o);
              });
            }
          });
        });
      }).catch(() => {
        this.emptyCourse();
      });
    },
    // 直播间窗口
    startFn(_o) {
      this.myScreenDialog.src = `${_o.url}?role=teacher&offline=true&platform=h5&scene=ykdrecord&server=${baseUrl.split('.')[1]}&roomid=${_o.roomid}&teacherid=${_o.teacher_id}&myid=${_o.uuid}&clientid=${_o.clientid}&token=${_o.token}`;
      this.myScreen.show = false;
      this.myScreen.loading = false;

      this.myScreenDialog.loading = true;
      this.myScreenDialog.show = true;

      // this.myScreenDialog.isfull = true;
      // requestAnimationFrame(() => {
      //   this.fullScreen(myScreenIframe);
      // })
    },
    // 直播间扣费
    startFee() {
      // const api = `/api/liveroom/${this.myScreen.roomid}/living`;
      let errNum = 0;
      // let successNum = 0;
      const func = async () => {
        const res = await setFee(this.$store.state.choicesSchool.id, this.myScreen.roomid);
        if (res && res.status_code === 200) {
          // successNum += 1;
          // console.log('收费中', successNum);
          this.rollFeeFun = setTimeout(() => {
            func();
            clearTimeout(this.rollFeeFun);
          }, 10000);
        } else {
          errNum += 1;
          // console.log('收费失败', errNum, res);
          if (errNum >= 3) {
            this.$message.warning('扣费失败，课时已停止！');
            clearTimeout(this.rollFeeFun);
            this.myScreenDialog.isfull = false;
            this.myScreenDialog.show = false;
            this.exitScreen();
          } else {
            this.rollFeeFun = setTimeout(() => {
              func();
              clearTimeout(this.rollFeeFun);
            }, 10000);
          }
        }
      };
      func();
    },
  },
  watch: {
    'myScreenDialog.show': function (vl) { // 直播间打开
      if (vl) {
        requestAnimationFrame(() => { // 请求动画重绘，动画帧
          this.myScreenDialog.isfull = true;
          this.fullScreen(myScreenIframe); // 全屏
          this.startFee();
        });
      } else {
        console.log('关闭全屏');
        clearTimeout(this.rollFeeFun);
        this.myScreenDialog.isfull = false;
        this.exitScreen(); // 退出全屏
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/MyClass/MyRecord/index.js